<div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-xxl modal-dialog-centered" role="document">
        <div class="modal-content user-profile-modal">
            <div class="modal-header">
                <h5 class="modal-title">{{ currentUserName }} Profile</h5>
                <button type="button" class="btn-close" aria-label="Close" (click)="closeUserProfileModal()"></button>
            </div>

            <div class="modal-body">
                <div class="row g-0">
                    <!-- LEFT MENU -->
                    <div class="left-menu col-12 col-md-2">
                        <ul class="menu-list">
                            <li *ngFor="let item of menuItems" [class.active]="selectedMenu === item.key"
                                (click)="selectMenu(item.key)">
                                <i [class]="item.icon"></i> {{ item.label }}
                            </li>
                            <!-- Vault Console - Hidden for now -->
                            <!-- <li class="vault-menu-mobile" (click)="openVaultAmendment()">
                                <i class="bi bi-safe"></i> Vault Console
                            </li> -->
                        </ul>
                    </div>

                    <!-- RIGHT CONTENT -->
                    <div class="right-content col-12 col-md-10">
                        <ng-container [ngSwitch]="selectedMenu">
                            <div *ngSwitchCase="'account'">
                                <h4>Account Details</h4>
                                <p>Show user info, email, etc.</p>
                            </div>

                            <div *ngSwitchCase="'password'">
                                <h4>Change Password</h4>
                                <form>
                                    <div class="mb-3">
                                        <label>Current Password</label>
                                        <input type="password" class="form-control">
                                    </div>
                                    <div class="mb-3">
                                        <label>New Password</label>
                                        <input type="password" class="form-control">
                                    </div>
                                    <button class="btn btn-primary">Update Password</button>
                                </form>
                            </div>

                            <!--if user has permission to view logs, show the menu item -->
                            <div *ngIf="isLogViewer">
                                <div *ngSwitchCase="'logs'">
                                    <h4>Activity Logs</h4>
                                    <p>List of recent login attempts or actions.</p>
                                    <div class="logs-wrapper">
                                        <!-- Loader while fetching logs -->
                                        <div *ngIf="isLoadingLogs" class="d-flex justify-content-center align-items-center py-5">
                                            <div class="spinner-border" role="status">
                                                <span class="visually-hidden">Loading logs...</span>
                                            </div>
                                        </div>
                                        <!-- Table displayed once logs are fetched -->
                                        <div *ngIf="!isLoadingLogs">
                                            <app-common-table [columnDefs]="columnDefs"
                                                [data]="userLogList"></app-common-table>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div *ngSwitchDefault>
                                <h4>Welcome!</h4>
                                <p>Select a menu item to view details.</p>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>